import React, { useState } from "react";
import { Select, Divider, Input, Button } from "antd";
import "@Styles/main.scss";

interface IProps {
    value?: string;
    onChange?: (value: string, option?: string) => void;
}

const GenderSelect: React.FC<IProps> = ({ value, onChange }: IProps) => {
    const [genderOptions, setGenderOptions] = useState<string[]>([
        "Female",
        "Male",
        "Non-binary",
        "Transgender",
        "Intersex",
        "Prefer not to say",
    ]);
    const [customGenderOption, setCustomGenderOption] = useState<string>("");

    const { Option } = Select;

    const onUpdateCustomGenderOpt = (e: React.FormEvent<HTMLInputElement>) => {
        const target = e.target as HTMLButtonElement;
        setCustomGenderOption(target.value);
        onChange?.("gender", target.value);
    };

    const addNewGenderOpt = () => {
        const currentOpts = [...genderOptions, customGenderOption];
        setGenderOptions(currentOpts);
        setCustomGenderOption("");
        onChange?.("gender", customGenderOption);
    };

    return (
        <Select
            onChange={(e) => onChange?.(e)}
            placeholder="I am best described as..."
            allowClear
            id="gender"
            value={value ?? null}
            dropdownRender={(menu) => (
                <div>
                    {menu}
                    <Divider style={{ margin: "4px 0" }} />
                    <div style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}>
                        <Input value={customGenderOption} onChange={onUpdateCustomGenderOpt} />
                        <Button className="secondary" onClick={addNewGenderOpt}>
                            Add option
                        </Button>
                    </div>
                </div>
            )}
        >
            {genderOptions.map((option) => (
                <Option key={option} value={option}>
                    {option}
                </Option>
            ))}
        </Select>
    );
};

export default GenderSelect;
